<template>
  <div>
    <FormWizardStepHeader
      title="Setting the scene"
      description="Make a good first impression by adding a high quality logo, investor name and a short and crisp description."
    />

    <FormItem
      invalid-message="Please upload a logo"
      :state="$v.logoImage.$dirty ? !$v.logoImage.$error : null"
    >
      <ImageUpload
        v-model="form.logoImage"
        title="Investor logo"
        file-input-id="logo"
        description="Choose a square image with a solid background color of at least 100x100px"
        required
      />
    </FormItem>

    <FormItem
      label="Investor name"
      invalid-message="Please enter the name"
      :state="$v.name.$dirty ? !$v.name.$error : null"
      required
    >
      <b-form-input
        v-model="form.name"
        maxlength="100"
        placeholder="Enter name"
        @blur="$v.name.$touch()"
        @change="onNameChange"
      />
    </FormItem>

    <FormItem
      label="Short description"
      invalid-message="The description must be between 100 and 2000 characters long"
      :state="$v.intro.$dirty ? !$v.intro.$error : null"
      required
    >
      <template slot="description">
        <FormInputLengthCounter
          label="Add a description between 100 and 2000 characters"
          :min="100"
          :max="2000"
          :text="form.intro"
        />
      </template>

      <template>
        <b-form-textarea
          v-model="form.intro"
          :rows="5"
          :max-rows="10"
          placeholder="Enter a short description here"
          @blur="$v.intro.$touch()"
        />
      </template>
    </FormItem>

    <ProfilesConflictingModal
      v-model="isConflictingModalOpen"
      :profiles="claimable"
      type="investors"
      @claim="onClaim"
    />
    <FundingClaimModal
      v-if="claim"
      v-model="isClaimModalOpen"
      :investor="claim"
      @submitted="onClaimSubmitted"
    />
    <ApplicationSentModal
      v-model="isClaimSentModalOpen"
      :success-data="claimSuccessData"
    />
  </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload'
import FormItem from '@/components/form/FormItem/index'
import FormInputLengthCounter from '@/components/form/FormInputLengthCounter'
import FormWizardStepHeader from '@/components/FormWizardStepHeader'

import ProfilesConflictingModal from '@/modals/profiles/ProfilesConflicting'
import FundingClaimModal from '@/modals/funding/FundingClaim'
import ApplicationSentModal from '@/modals/ApplicationSent'
import InvestorModel from '@/models/Investor'

export default {
  name: 'InvestorFormStepSettingTheScene',
  components: {
    FormWizardStepHeader,
    FormInputLengthCounter,
    FormItem,
    ImageUpload,
    ProfilesConflictingModal,
    FundingClaimModal,
    ApplicationSentModal
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    },
    investor: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      },
      isConflictingModalOpen: false,
      claimable: [],
      isClaimModalOpen: false,
      claim: null,
      isClaimSentModalOpen: false,
      claimSuccessData: {
        title: 'Your request is sent!',
        subtitle:
          'Thank you for your request to claim your investor profile. You will be informed via e-mail when we’ve approved your request or whenever  we have additional questions. The reviewing process normally takes 1-2 business days.',
        image: 'paper-plane.svg',
        label: 'Close',
        width: '447'
      }
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    },
    isClaimSentModalOpen(value, previousValue) {
      if (previousValue && !value) {
        this.$emit('exit')
      }
    }
  },
  methods: {
    async onNameChange() {
      if (this.investor || !this.form.name) {
        return
      }
      try {
        const conflicting = await this.$axios.$get('investors/conflicting', {
          params: {
            name: this.form.name,
            include: 'claim'
          }
        })
        const claimable = conflicting.filter((item) => item.claim)
        if (claimable.length) {
          this.claimable = claimable.map((item) => new InvestorModel(item))
          this.isConflictingModalOpen = true
        }
      } catch (err) {}
    },
    onClaim(investor) {
      this.isConflictingModalOpen = false
      this.claim = investor
      this.isClaimModalOpen = true
    },
    onClaimSubmitted() {
      this.isClaimModalOpen = false
      this.isClaimSentModalOpen = true
    }
  }
}
</script>
